import script from "./AdminCustomersList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCustomersList.vue?vue&type=script&setup=true&lang=js"

import "./AdminCustomersList.vue?vue&type=style&index=0&id=589c7994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589c7994"]])

export default __exports__